import {
  IconBricksFilled,
  IconBricksOutline,
  IconChatFilled,
  IconChatOutline,
  IconCode,
  IconCreditCardFilled,
  IconHomeFilled,
  IconHomeOutline,
  IconLink,
  IconMultipleUsersFilled,
  IconMultipleUsersOutline,
  IconPound,
  IconPresentationFilled,
  IconPresentationOutline,
  IconRocket,
} from '@iwoca/icons';

import { ValidRoutePaths } from '../../../routing/utils';
import { TMenuIcon } from '../SellerNavBar';

type TExternalLink = {
  href: string;
  newTab: boolean;
};

export type TMenuLink = {
  title: string;
  internal_path?: ValidRoutePaths;
  external_link?: TExternalLink;
  onClick?: () => void;
  icon?: TMenuIcon | null;
  promotional_badge?: {
    launch_date: Date;
    expiry_days: number;
  };
};

export const baseLinks: TMenuLink[] = [
  {
    title: 'Home',
    internal_path: '/pay/dashboard',
    icon: { normal: <IconHomeOutline />, selected: <IconHomeFilled /> },
  },
  {
    title: 'Pay Links',
    internal_path: '/pay/pay-links/universal',
    icon: { normal: <IconLink />, selected: <IconLink /> },
  },
  {
    title: 'Customers',
    internal_path: '/pay/customers',
    icon: {
      normal: <IconMultipleUsersOutline />,
      selected: <IconMultipleUsersFilled />,
    },
    promotional_badge: {
      launch_date: new Date('2025-11-05'),
      expiry_days: 30,
    },
  },
  {
    title: 'Payments',
    internal_path: '/pay/payments',
    icon: {
      normal: <IconCreditCardFilled />,
      selected: <IconCreditCardFilled />,
    },
  },
  {
    title: 'Fees',
    internal_path: '/pay/fees',
    icon: { normal: <IconPound />, selected: <IconPound /> },
  },
  {
    title: 'Spending Limits',
    internal_path: '/pay/spending-limits',
    icon: {
      normal: <IconPresentationOutline />,
      selected: <IconPresentationFilled />,
    },
  },
  {
    title: 'Integrations',
    internal_path: '/pay/integrations',
    icon: { normal: <IconBricksOutline />, selected: <IconBricksFilled /> },
  },
];

export const secondaryLinks: TMenuLink[] = [
  {
    title: 'API docs',
    external_link: { href: 'https://iwoca.co.uk/ecom/docs/', newTab: true },
    icon: { normal: <IconCode />, selected: <IconCode /> },
  },
  {
    title: 'Launch pack',
    external_link: {
      href: 'https://www.coda.io/d/Welcome-to-iwocaPay_dx9e47R5IPf',
      newTab: true,
    },
    icon: { normal: <IconRocket />, selected: <IconRocket /> },
  },
  {
    title: 'Refer a business',
    internal_path: '/pay/rewards',
    icon: { normal: <IconChatOutline />, selected: <IconChatFilled /> },
  },
];
